import { Modal, Collapse, List, Typography, Button } from 'antd';
import type { BulkArchiveEntityLabel, BulkArchiveResult } from '~/types/bulkArchive';

const { Panel } = Collapse;
const { Text } = Typography;

export interface BulkArchiveResultModalProps {
  open: boolean;
  entityLabel: BulkArchiveEntityLabel;
  result: BulkArchiveResult;
  onClose: () => void;
}

export const BulkArchiveResultModal = ({ open, entityLabel, result, onClose }: BulkArchiveResultModalProps) => (
  <Modal
    open={open}
    title={`Bulk archive results — ${entityLabel}`}
    onCancel={onClose}
    footer={null}
    data-testid="bulk-archive-result-modal"
  >
    <Collapse defaultActiveKey={result.failed.length ? ['failed'] : ['succeeded']}>
      <Panel header={`Succeeded (${result.succeeded.length})`} key="succeeded">
        <List
          size="small"
          dataSource={result.succeeded}
          renderItem={(id) => (
            <List.Item>
              <Text copyable>{id}</Text>
            </List.Item>
          )}
        />
      </Panel>
      <Panel header={`Failed (${result.failed.length})`} key="failed">
        <List
          size="small"
          dataSource={result.failed}
          renderItem={({ id, reason }) => (
            <List.Item>
              <Text copyable>{id}</Text>
              <Text type="secondary" style={{ marginLeft: 12 }}>
                {reason}
              </Text>
            </List.Item>
          )}
        />
      </Panel>
    </Collapse>
    <div style={{ marginTop: 16, textAlign: 'right' }}>
      <Button onClick={onClose} data-testid="bulk-archive-result-modal-close">
        Close
      </Button>
    </div>
  </Modal>
);
